import Get from '../services/Get';
import Post from '../services/Post';
import Put from '../services/Put';
import Delete from '../services/Delete';
import PostFormData from '../services/PostFormData';

import { nexcareVersion } from '../config/serviceConfig';

// Menu Role
const getInitiateRole = (token) => Get(`/${nexcareVersion}/nexcare/roles/initiate`, token);
const getListRole = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/roles?page=${page}&limit=${limit}`, token);
const getListFilterRole = (page, limit, level, token) => Get(`/${nexcareVersion}/nexcare/roles?page=${page}&limit=${limit}&filter=role.level eq ${level}`, token);
const getDetailRole = (id, token) => Get(`/${nexcareVersion}/nexcare/roles/${id}`, token);
const postDataRole = (data, token) => Post(`/${nexcareVersion}/nexcare/roles`, data, token);
const putDataRole = (id, data, token) => Put(`/${nexcareVersion}/nexcare/roles/${id}`, data, token);
const deleteDataRole = (id, data, token) => Delete(`/${nexcareVersion}/nexcare/roles/${id}`, data, token);

const getListPermission = (token) => Get(`/${nexcareVersion}/nexcare/permissions?start_from=2`, token);

// Menu Data Group
const getInitiateDataGroup = (token) => Get(`/${nexcareVersion}/nexcare/data-group/initiate`, token);
const getListDataGroup = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/data-group?page=${page}&limit=${limit}`, token);
const getDetailDataGroup = (id, token) => Get(`/${nexcareVersion}/nexcare/data-group/${id}`, token);
const postDataDataGroup = (data, token) => Post(`/${nexcareVersion}/nexcare/data-group`, data, token);
const putDataDataGroup = (id, data, token) => Put(`/${nexcareVersion}/nexcare/data-group/${id}`, data, token);
const deleteDataDataGroup = (id, data, token) => Delete(`/${nexcareVersion}/nexcare/data-group/${id}`, data, token);

const getListDistributorDataGroup = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/data-group/user-customer/distributor?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc`, token);
const getFilterDistributorDataGroup = (page, limit, id, token) => Get(`/${nexcareVersion}/nexcare/user-customer/distributor?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc&list_user_nexcare_id=${id}`, token);
const getSearchDistributorDataGroup = (page, limit, filter, token) => Get(`/${nexcareVersion}/nexcare/data-group/user-customer/distributor?page=${page}&limit=${limit}&filter=user_nexcare.alias_name like ${filter}&order=user_nexcare.alias_name asc`, token);
const getListPrincipalDataGroup = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/data-group/user-customer/principal?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc`, token);
const getFilterPrincipalDataGroup = (page, limit, id, token) => Get(`/${nexcareVersion}/nexcare/user-customer/principal?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc&list_user_nexcare_id=${id}`, token);
const getSearchPrincipalDataGroup = (page, limit, filter, token) => Get(`/${nexcareVersion}/nexcare/data-group/user-customer/principal?page=${page}&limit=${limit}&filter=user_nexcare.alias_name like ${filter}&order=user_nexcare.alias_name asc`, token);

// Menu User
const getInitiateUser = (token) => Get(`/${nexcareVersion}/nexcare/user-nexcare/initiate`, token);
const getListUser = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/user-nexcare?page=${page}&limit=${limit}`, token);
const getListComplaint = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/user-nexcare/complaint?page=${page}&limit=${limit}`, token);
const getListFilterRoleUser = (page, limit, level, token) => Get(`/${nexcareVersion}/nexcare/user-nexcare/roles?page=${page}&limit=${limit}&filter=role.level eq ${level}`, token);
const getListDataGroupUser = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/user-nexcare/data-group?page=${page}&limit=${limit}`, token);
const getDetailUser = (id, token) => Get(`/${nexcareVersion}/nexcare/users/${id}`, token);
const postDataAddResourceUser = (data, token) => Post(`/${nexcareVersion}/nexcare/users/resource`, data, token);
const postDataAddUser = (data, token) => Post(`/${nexcareVersion}/nexcare/users`, data, token);
const putDataEditUser = (data, id, token) => Put(`/${nexcareVersion}/nexcare/user-nexcare/${id}`, data, token);
const deleteDataUser = (id, data, token) => Delete(`/${nexcareVersion}/nexcare/users/${id}`, data, token);

// Menu Data Distributor
const getListDataCustomer = (id, token) => Get(`/${nexcareVersion}/nexcare/master-customer/${id}`, token);
const postDataDataCustomer = (data, token) => Post(`/${nexcareVersion}/nexcare/master-customer`, data, token);

const getListDistributorDataCustomer = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/data-customer/user-customer/distributor?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc`, token);
const getSearchDistributorDataCustomer = (page, limit, filter, token) => Get(`/${nexcareVersion}/nexcare/data-customer/user-customer/distributor?page=${page}&limit=${limit}&filter=user_nexcare.alias_name like ${filter}&order=user_nexcare.alias_name asc`, token);
const getListPrincipalDataCustomer = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/data-customer/user-customer/principal?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc`, token);
const getSearchPrincipalDataCustomer = (page, limit, filter, token) => Get(`/${nexcareVersion}/nexcare/data-customer/user-customer/principal?page=${page}&limit=${limit}&filter=user_nexcare.alias_name like ${filter}&order=user_nexcare.alias_name asc`, token);

// Menu Shift
const getInitiateShift = (token) => Get(`/${nexcareVersion}/nexcare/list-shift/initiate`, token);
const getListShift = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/list-shift?page=${page}&limit=${limit}`, token);
const getDetailShift = (id, token) => Get(`/${nexcareVersion}/nexcare/list-shift/${id}`, token);
const postDataAddShift = (data, token) => Post(`/${nexcareVersion}/nexcare/list-shift`, data, token);
const putDataEditShift = (id, data, token) => Put(`/${nexcareVersion}/nexcare/list-shift/${id}`, data, token);
const deleteDataShift = (id, data, token) => Delete(`/${nexcareVersion}/nexcare/list-shift/${id}`, data, token);

// Menu Import
const getInitiateImport = (token) => Get(`/${nexcareVersion}/nexcare/import/initiate`, token);
const getTemplateImport = (token, type) => Get(`/${nexcareVersion}/nexcare/import/download/${type}`, token);
const postDataImportValidate = (data, token) => PostFormData(`/${nexcareVersion}/nexcare/import/validate`, data, token);
const postDataImportConfirm = (data, token) => Post(`/${nexcareVersion}/nexcare/import/confirm`, data, token);

const getListCustomer = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/user-customer/distributor?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc`, token);
const getFilterCustomer = (page, limit, id, token) => Get(`/${nexcareVersion}/nexcare/user-customer/distributor?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc&list_user_nexcare_id=${id}`, token);
const getSearchCustomer = (page, limit, filter, token) => Get(`/${nexcareVersion}/nexcare/user-customer/distributor?page=${page}&limit=${limit}&filter=user_nexcare.alias_name like ${filter}&order=user_nexcare.alias_name asc`, token);
const getAllCustomer = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/user-nexcare/user-cs?page=${page}&limit=${limit}&filter=is_lead eq true&is_all=true`, token);

const getListPrincipal = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/user-customer/principal?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc`, token);
const getFilterPrincipal = (page, limit, id, token) => Get(`/${nexcareVersion}/nexcare/user-customer/principal?page=${page}&limit=${limit}&order=user_nexcare.alias_name asc&list_user_nexcare_id=${id}`, token);
const getSearchPrincipal = (page, limit, filter, token) => Get(`/${nexcareVersion}/nexcare/user-customer/principal?page=${page}&limit=${limit}&filter=user_nexcare.alias_name like ${filter}&order=user_nexcare.alias_name asc`, token);

const API_MASTER_DATA = {
    getInitiateRole,
    getListRole,
    getListFilterRole,
    getDetailRole,
    postDataRole,
    putDataRole,
    deleteDataRole,
    getListPermission,
    getListDistributorDataGroup,
    getFilterDistributorDataGroup,
    getSearchDistributorDataGroup,
    getListPrincipalDataGroup,
    getFilterPrincipalDataGroup,
    getSearchPrincipalDataGroup,
    getInitiateDataGroup,
    getListDataGroup,
    getDetailDataGroup,
    postDataDataGroup,
    putDataDataGroup,
    deleteDataDataGroup,
    getInitiateUser,
    getListUser,
    putDataEditUser,
    getDetailUser,
    getListComplaint,
    getListFilterRoleUser,
    getListDataGroupUser,
    postDataAddResourceUser,
    postDataAddUser,
    deleteDataUser,
    getInitiateImport,
    getTemplateImport,
    postDataImportValidate,
    postDataImportConfirm,
    getListDataCustomer,
    postDataDataCustomer,
    getListDistributorDataCustomer,
    getSearchDistributorDataCustomer,
    getListPrincipalDataCustomer,
    getSearchPrincipalDataCustomer,
    getInitiateShift,
    getListShift,
    getDetailShift,
    postDataAddShift,
    putDataEditShift,
    deleteDataShift,
    getListCustomer,
    getFilterCustomer,
    getSearchCustomer,
    getAllCustomer,
    getListPrincipal,
    getFilterPrincipal,
    getSearchPrincipal
}

export default API_MASTER_DATA;